import { render, staticRenderFns } from "./AphasiaTherapyResourcesLogo.vue?vue&type=template&id=545ac79e"
import script from "./AphasiaTherapyResourcesLogo.vue?vue&type=script&lang=js"
export * from "./AphasiaTherapyResourcesLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports